<div class="td-wb-learn-duration__overlay">
  @if (inProgress()) {
    <span
      class="td-wb-learn-duration__overlay-text"
      translate="tdWb.learn.duration.TEXT"
      [translateParams]="{ duration: timeRemaining() | tdWbDuration: { useWords: true, truncateTo: isCourse() ? 'minutes' : 'seconds' }}"></span>
  } @else {
    @if (duration() !== undefined) {
      <span class="td-wb-learn-duration__overlay-text"
            [innerText]="duration() | tdWbDuration: { useWords: true, truncateTo: isCourse() ? 'minutes' : 'seconds' }"></span>
    }
  }
</div>
